(() => {
    const CONFIG = {
        ROOT_SELECTOR: '[id^="hulkapps_custom_options_"]',
        INPUT_SELECTOR:
            '.hulkapps_option_set .hulkapps_option.custom-length input[type="number"]',
        PRICE_SELECTOR: '[data-hulk-custom-price]',
        OUTPUT_SELECTOR:
            '.hulkapps_option.simple-formula input.hulkapps_option_child',
        BREAKDOWN_CONTAINER_CLASS: 'hulkapps-compound-breakdown',
        INIT_TIMEOUT_MS: 15000
    };

    let isBound = false;

    /* ---------------- INIT ---------------- */

    function init() {
        console.log('Init hulk custom price');
        if (isBound) return;
        isBound = true;

        document.addEventListener('change', handleLengthChange, true);
    }

    /* ---------------- EVENT HANDLER ---------------- */

    function handleLengthChange(event) {
        console.log(event);
        console.log(event.target.closest(CONFIG.INPUT_SELECTOR))
        const input = event.target.closest(CONFIG.INPUT_SELECTOR);
        if (!input) return;

        // Ensure event belongs to Hulk UI
        if (!input.closest(CONFIG.ROOT_SELECTOR)) return;
        console.log(!input.closest(CONFIG.ROOT_SELECTOR), 'Closest');

        const length = parseFloat(input.value);
        console.log('Length: ', length);
        if (!Number.isFinite(length) || length <= 0) return;

        const outputEl = document.querySelector(CONFIG.OUTPUT_SELECTOR);
        if (!outputEl) return;

        const pricing = resolvePricing(length);
        console.log(resolvePricing(length));
        if (!pricing) return;
        console.log("Pricing: ", pricing);

        outputEl.value = pricing.total;
        outputEl.dispatchEvent(new Event('change', { bubbles: true }));

        if (pricing.breakdown) {
            //renderCompoundBreakdown(pricing.breakdown);
        }
    }

    /* ---------------- PRICING ---------------- */

    function resolvePricing(length) {
        return isComplexProduct()
            ? calculateCompoundPrice(length)
            : calculateSimplePrice(length);
    }

    function calculateSimplePrice(length) {
        const priceEl =
            document.querySelector(CONFIG.PRICE_SELECTOR) ||
            document.querySelector('.price-item.price-item-regular');

        const pricePerMeter = parseFloat(priceEl?.dataset?.hulkCustomPrice);
        if (!Number.isFinite(pricePerMeter)) return null;

        return {
            total: (((pricePerMeter / 100) * length) / 100).toFixed(2)
        };
    }

    function calculateCompoundPrice(length) {
        const bundle = window.hulkBundleMap;
        console.log(bundle,' Is bundle');
        if (!bundle) return null;

        const ports = getChosenPorts();
        console.log('Ports: ', getChosenPorts());
        if (ports.length < 2) return null;

        const meterPrice = (bundle.pricePerMeter / 100) * length;

        const breakdown = {
            'Preis Rollenware': meterPrice,
            'Basispreis': bundle.basePrice,
            'Anschluss 1': ports[0].price,
            'Anschluss 2': ports[1].price
        };

        const totalCents = meterPrice + bundle.basePrice;

        return {
            total: (totalCents / 100).toFixed(2),
            breakdown
        };
    }

    /* ---------------- PORTS ---------------- */

    function getChosenPorts() {
        return Array.from(
            document.querySelectorAll(
                'input[name^="Anschluss 1" i]:checked, input[name^="Anschluss 2" i]:checked'
            )
        )
            .map(input => {
                const entry = window.hulkBundleMap.portData.find(
                    p => p.port_name === input.value
                );

                if (!entry || !entry.port_price?.amount) return null;

                return {
                    name: entry.port_name,
                    price: parseFloat(entry.port_price.amount) * 100
                };
            })
            .filter(Boolean);
    }

    function isComplexProduct() {
        return window.hulkapps?.product?.tags?.includes(
            'hulk-complex-product'
        );
    }

    /* ---------------- DOM ---------------- */

    function renderCompoundBreakdown(breakdown) {
        console.log('Here breakdown');
        removeExistingBreakdown();

        const container = document.createElement('div');
        container.className = CONFIG.BREAKDOWN_CONTAINER_CLASS;

        const entries = Object.entries(breakdown);

        entries.forEach(([label, cents], index) => {
            const row = document.createElement('div');
            row.className = 'hulkapps-compound-row';

            const isLast = index === entries.length - 1;
            const plus = isLast ? '' : ' +';

            row.innerHTML = `
                <span><b>${label}:</b></span>
                <span>${formatMoney(cents)} ${plus}</span>
            `;

            container.appendChild(row);
        });
        console.log('COntainer: ', container);

        document.querySelector('#option_total')?.insertAdjacentElement('beforebegin', container);
    }

    function removeExistingBreakdown() {
        document.querySelector('.hulkapps_product_options').querySelector(`.${CONFIG.BREAKDOWN_CONTAINER_CLASS}`)
            ?.remove();
    }

    /* ---------------- UTILS ---------------- */

    function formatMoney(cents) {
        return window.hulkapps.money_format.replace(
            '{{amount_with_comma_separator}}',
            (cents / 100).toFixed(2).replace('.', ',')
        );
    }

    /* ---------------- BOOTSTRAP ---------------- */

    const start = Date.now();
    const observer = new MutationObserver(() => {
        if (document.querySelector(CONFIG.ROOT_SELECTOR)) {
            observer.disconnect();
            init();
        }

        if (Date.now() - start > CONFIG.INIT_TIMEOUT_MS) {
            observer.disconnect();
        }
    });

    observer.observe(document.documentElement, {
        childList: true,
        subtree: true
    });
})();
